import { render, staticRenderFns } from "./public-audio2.vue?vue&type=template&id=de4cf33e&scoped=true&"
import script from "./public-audio2.vue?vue&type=script&lang=js&"
export * from "./public-audio2.vue?vue&type=script&lang=js&"
import style0 from "./public-audio2.vue?vue&type=style&index=0&id=de4cf33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4cf33e",
  null
  
)

export default component.exports